import { render, staticRenderFns } from "./SimpleWidget.vue?vue&type=template&id=1b025494&scoped=true"
import script from "./SimpleWidget.vue?vue&type=script&lang=js"
export * from "./SimpleWidget.vue?vue&type=script&lang=js"
import style0 from "./SimpleWidget.vue?vue&type=style&index=0&id=1b025494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b025494",
  null
  
)

export default component.exports